import React from 'react';
import PropTypes from 'prop-types';

const AlphabetItem = ({id, registerPos}) => {
    const fix = React.useRef();
    React.useEffect(() => {
        registerPos(id, fix.current.offsetTop);
    });

    return <h6 className="card-divider" ref={fix}>{`${id}`}</h6>;
};

AlphabetItem.propTypes = {
    id: PropTypes.string,
    registerPos: PropTypes.func,
};

export default AlphabetItem;
